export default (state, action) => {
    let { historicalDialogue, inboxData } = state

    const { type } = state

    if (!historicalDialogue) {
        return state
    }

    const { payload } = action
    const { message, doNotSend } = payload

    if (doNotSend) {
        message.IgnoreUpdateFlow = true
    }

    message.MessageStatus = 'PROCESSING_DONE'

    const messageIndex = historicalDialogue.findIndex(
        element => element.MessageId === message.MessageId
    )

    if (messageIndex !== -1) {
        historicalDialogue.splice(messageIndex, 1)
    }

    historicalDialogue = [...historicalDialogue, { ...message }]

    let { threads } = inboxData

    // Remove thread from inbox, do not touch if 'all'
    if (type === 'inbox') {
        threads = threads.filter(
            thread => !(
                thread.account === message.AccountId
                    && thread.user === message.UserId
                    && thread.conversationId === message.ConversationId
            )
        )
    }

    inboxData = { ...inboxData, threads: [...threads] }

    const newState = {
        ...state,
        historicalDialogue,
        inboxData,
    }

    return newState
}
